import { lazy, useMemo, type FC } from 'react';
import type { HydrogenShipperBookingOverviewRequestParams } from 'src/apis/hydrogen-fcfs/types';
import { useHydrogenFcfsRootLink } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import { useHydrogenShipperBookingOverview } from 'src/apis/hydrogen-fcfs/use-hydrogen-shipper-booking-overview';
import { PageSpinner } from 'src/components/spinner-container';
import { useHydrogenShipperBookingOverviewPageParams } from 'src/pages/h2/fcfs/shipper-bookings/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const HydrogenShipperBookingOverview: FC = () => {
  const pageParams = useHydrogenShipperBookingOverviewPageParams();
  const url = useHydrogenFcfsRootLink('bookingOverviewShipper');

  const requestParams = useMemo(
    () =>
      ({
        ...pageParams.value,
        networkPointOrBundleId: pageParams.value.networkPointOrBundle?.value,
      }) satisfies HydrogenShipperBookingOverviewRequestParams,
    [pageParams.value]
  );

  const overviewRequest = useHydrogenShipperBookingOverview({
    url,
    params: requestParams,
  });

  if (!overviewRequest.response) return <PageSpinner />;

  return (
    <Page
      pageParams={pageParams}
      requestParams={requestParams}
      overviewRequest={overviewRequest}
    />
  );
};
